import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


import { Autoplay, Pagination, Navigation } from "swiper";

const Crousel = () => {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        
      >      
        {/* <SwiperSlide>
            <img src="../assets/DSC_5026.jpg" alt="pic"
            className="object-cover h-[36rem]  w-full" />
        </SwiperSlide> */}
        <SwiperSlide> <img src="../assets/house_5555.JPG" alt="pic"
            className="object-cover lg:h-[36rem] md:h-[36rem]  w-full" /></SwiperSlide>
        <SwiperSlide> <img src="../assets/house_5562.JPG" alt="pic"
            className="object-cover lg:h-[36rem] md:h-[36rem]  w-full" /></SwiperSlide>
        <SwiperSlide> <img src="../assets/house_2101.JPG" alt="pic"
            className="object-cover lg:h-[36rem] md:h-[36rem]  w-full" /></SwiperSlide>        
      </Swiper>
    </>
  )
}

export default Crousel